import { DatePicker } from "antd";
import locale from "antd/locale/fr_FR";
import classnames from "classnames";
import {
  MdCheck,
  MdPriorityHigh,
  MdLock,
  MdOutlineKeyboard,
} from "react-icons/md";
import Label from "shared/components/Label";

const Look = ({
  processing,
  label,
  errors,
  icon,
  touched,
  props,
  direction,
  required,
  optional,
  right,
  success,
  showSuccessIcon = true,
  placeholder,
  className,
  format,
  onChange,
  onBlur,
  value,
  disabledDate,
  ownerDocument,
  ...rest
}) => (
  <div
    className={classnames(
      "datepicker__wrapper",
      {
        __error: processing.showError,
        __success: success && !processing.displayError,
      },
      direction,
    )}
  >
    <Label
      label={label}
      required={required}
      optional={optional}
      right={right}
    />
    <div
      className={classnames("datepicker__wrapper--field", {
        "datepicker__wrapper--field--filled": processing.isFilled,
      })}
    >
      {icon && <span className="datepicker__icon">{icon}</span>}
      <DatePicker
        locale={locale}
        placeholder={processing.texts.PLACEHOLDER}
        suffixIcon={null}
        {...props}
        className={classnames(className, {
          "disabled--input": rest.disabled,
          "datepicker--with-icon": !!icon,
          "datepicker--filled": processing.isFilled,
        })}
        {...rest}
        {...processing.field}
        renderExtraFooter={() =>
          processing.showHint && (
            <div className="datePicker-hint-text">
              <MdOutlineKeyboard size={24} />
              <span>{processing.texts.HINT}</span>
            </div>
          )
        }
      />

      {processing.showError && (
        <MdPriorityHigh className="input--error-icon" size={20} />
      )}

      {success && showSuccessIcon && !processing.displayError && (
        <MdCheck className="input--success-icon" size={20} />
      )}

      {rest.disabled && !processing.showError && (
        <MdLock className="input--disabled-icon" size={16} />
      )}
    </div>
    {processing.showError && (
      <p className={"input--errors"}>{processing.displayError}</p>
    )}
  </div>
);

export default Look;
